export default "__VITE_ASSET__BEM2CYUo__"